module.exports = __webpack_public_path__ + "static/bmg-14e82f58d7ab35d6c4044c24a343dc8c.png";